import type { GraphQLService } from '@affine/core/modules/cloud';
import { workspaceBlobQuotaQuery } from '@affine/graphql';
import { Store } from '@toeverything/infra';

export class WorkspaceQuotaBlobStore extends Store {
  constructor(private readonly graphqlService: GraphQLService) {
    super();
  }

  async fetchWorkspaceQuotaBlob(workspaceId: string, signal?: AbortSignal) {
    const data = await this.graphqlService.gql({
      query: workspaceBlobQuotaQuery,
      variables: {
        id: workspaceId,
      },
      context: {
        signal,
      },
    });
    return data.getWorkspace.quota;
  }
}
